/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Transfer_Target_RequiredInputs */

const vi_order_settlement_transfer_target_required = /** @type {(inputs: Order_Settlement_Transfer_Target_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn khách chuyển vào TK HTX hay TK riêng của tài xế`)
};

/**

* @param {Order_Settlement_Transfer_Target_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_transfer_target_required = /** @type {((inputs?: Order_Settlement_Transfer_Target_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Transfer_Target_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_transfer_target_required(inputs)
});